const queryKeys = {
  policies: {
    all: (partyId: string) => ['policies', partyId] as const,

    lists: (partyId: string) =>
      [...queryKeys.policies.all(partyId), 'list'] as const,
    details: (partyId: string) =>
      [...queryKeys.policies.all(partyId), 'details'] as const,

    list: (partyId: string, filter: unknown) =>
      [...queryKeys.policies.lists(partyId), filter] as const,
    byId: (id: string) => [...queryKeys.policies.details(''), id] as const,
  },
  policyPackages: {
    all: (partyId: string) => ['policy-packages', partyId] as const,

    lists: (partyId: string) =>
      [...queryKeys.policyPackages.all(partyId), 'list'] as const,
    details: (partyId: string) =>
      [...queryKeys.policyPackages.all(partyId), 'details'] as const,

    list: (partyId: string, filter: unknown) =>
      [...queryKeys.policyPackages.lists(partyId), filter] as const,
    byId: (partyId: string, id: string) =>
      [...queryKeys.policyPackages.details(partyId), id] as const,
  },
};

export default queryKeys;
